/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { useAlert } from '../../../Common/hooks';
import { getPayersFilters } from '../../selectors';
import { getPayersReports } from '../../services';
import { payersError } from '../../constants';

const usePayersReport = () => {
  const filters = useSelector(getPayersFilters);
  const { showAlert } = useAlert();
  const [payersReports, setPayersReports] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { aggregatorID } = filters;

  const handleFilterChange = async () => {
    if (aggregatorID) {
      setIsLoading(true);
      const { payers, status } = await getPayersReports(aggregatorID);
      if (status === 404) {
        showAlert({ color: 'error', icon: 'exclamation', message: payersError });
      }

      setPayersReports(payers);
      setIsLoading(false);
    } else {
      setPayersReports([]);
    }
  };

  useEffect(() => {
    handleFilterChange();
  }, [filters]);

  return {
    payersReports,
    isLoading,
  };
};

export default usePayersReport;
